import VolumeDiscountsError from './volumeDiscountsError';
class VolumeDiscountPropertyNotFound extends VolumeDiscountsError {
    crowdfundingPropertyId;
    constructor(crowdfundingPropertyId, options) {
        super('Crowdfunding property not found', options);
        this.crowdfundingPropertyId = crowdfundingPropertyId;
    }
}
export default VolumeDiscountPropertyNotFound;
